import React, { useState, useEffect } from 'react';
import { easeInOut, motion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';
import './about.scss';
import { urlFor, client } from '../../client';

const About = () => {
  const [abouts, setAbouts] = useState([]);

  useEffect(() => {
    const query = '*[_type == "abouts"]';

    client.fetch(query).then((data) => {
      setAbouts(data);
    });
  }, []);

  return (
    <>
    <motion.div  whileInView={{ opacity:1}}
  className="head-textdiv">
      <p className="about-head-text" style={{ marginTop: 20 }}>A passionate <span style={{color:'#007200'}}>M</span><span style={{color:'#a53860'}}>E</span><span style= {{color:'#B388EB'}}>R</span><span style={{color:'#f18701'}}>N</span> Stack developer with expertise in building robust and scalable web applications. I have a deep understanding of front-end development.</p> <p>As a <span style={{color:'#007200'}}>M</span><span style={{color:'#a53860'}}>E</span><span style= {{color:'#B388EB'}}>R</span><span style={{color:'#f18701'}}>N</span>  Stack developer, I am constantly learning and staying up-to-date with the latest technologies and trends in web development. I am excited to take on new challenges and apply my skills to deliver high-quality solutions that meet the unique requirements of each project.
If you are looking for a dedicated and skilled <span style={{color:'#007200'}}>M</span><span style={{color:'#a53860'}}>E</span><span style= {{color:'#B388EB'}}>R</span><span style={{color:'#f18701'}}>N</span>  Stack developer to bring your web application ideas to life, feel free to get in touch.</p>
      </motion.div><div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: "1.02",ease:"",  borderRadius: "15px" }}
            transition={{ duration: 0, type: 'tween' }}
            className="app__profile-item"
            key={about.title + index}
          >
            <img style={{height:'100%'}} src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>{about.title}</h2>
            <p className="p-text" style={{ marginTop: 10 }}>{about.description}</p>
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  'app__whitebg',
);
